import { render } from "./LinkIcon.vue?vue&type=template&id=6f7fe894&scoped=true"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"

import "./LinkIcon.vue?vue&type=style&index=0&id=6f7fe894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7fe894"]])

export default __exports__